import React, { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { fileUrl } from "../components/site/HeroSlides";

const EMOJI = { heart: "❤️", laugh: "😂", cry: "🥹", fire: "🔥", clap: "👏" };

export default function PremierePage() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const phone = params.get("mode") === "phone";
  const [s, setS] = useState(null);
  const [now, setNow] = useState(Date.now());
  const [floats, setFloats] = useState([]);
  const [armed, setArmed] = useState(phone);
  const skew = useRef(0);
  const seen = useRef(new Set());
  const vid = useRef();
  useEffect(() => {
    let stop = false;
    async function poll() {
      try {
        const { data } = await api.get(`/public/weddings/${slug}/premiere`);
        skew.current = new Date(data.server_now).getTime() - Date.now();
        const fresh = data.reactions.filter((r) => !seen.current.has(r.id));
        fresh.forEach((r) => seen.current.add(r.id));
        if (fresh.length && seen.current.size > fresh.length) setFloats((f) => [...f.slice(-30), ...fresh.map((r) => ({ ...r, x: 10 + Math.random() * 80 }))]);
        setS(data);
      } catch { /* keep last state */ }
      if (!stop) setTimeout(poll, 2000);
    }
    poll();
    const t = setInterval(() => setNow(Date.now()), 250);
    return () => { stop = true; clearInterval(t); };
  }, [slug]);
  const serverNow = now + skew.current;
  const start = s?.starts_at ? new Date(s.starts_at).getTime() : 0;
  const live = s?.status === "live";
  const left = Math.ceil((start - serverNow) / 1000);
  useEffect(() => {
    const v = vid.current;
    if (!v || !live || left > 0) return;
    const want = (serverNow - start) / 1000;
    if (v.duration && want > v.duration) return;
    if (Math.abs(v.currentTime - want) > 1.5) v.currentTime = want;
    if (v.paused) v.play().catch(() => {});
  }, [now, live, left, start, serverNow]);
  const device = useRef(localStorage.getItem("lif_dev") || (() => { const d = Math.random().toString(36).slice(2, 12); localStorage.setItem("lif_dev", d); return d; })());
  const react = (kind) => {
    setFloats((f) => [...f.slice(-30), { id: `me${Date.now()}`, kind, x: 30 + Math.random() * 40 }]);
    api.post(`/public/weddings/${slug}/premiere/react`, { kind, device: device.current }).catch(() => {});
  };
  if (!s) return <div className="min-h-screen bg-black" />;
  return (
    <div className="fixed inset-0 bg-black text-white overflow-hidden" data-testid="premiere-page">
      {live && left <= 0 && <video ref={vid} key={s.session} src={fileUrl(s.path)} playsInline muted={phone} className="absolute inset-0 w-full h-full object-contain" data-testid="premiere-video" />}
      {(!live || left > 0) && (
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          <p className="text-[var(--gold)] uppercase tracking-[0.4em] text-xs sm:text-sm">World premiere</p>
          <p className="font-script text-5xl sm:text-7xl text-[var(--gold)] mt-4">{s.couple_names}</p>
          {live ? <p className="font-serif text-[120px] sm:text-[220px] leading-none mt-6" data-testid="premiere-countdown">{left}</p>
            : <p className="text-white/60 mt-6" data-testid="premiere-waiting">The film starts soon. Stay close to the screen.</p>}
          {s.hashtag && <p className="text-white/50 mt-4">{s.hashtag}</p>}
        </div>
      )}
      {floats.map((f) => <span key={f.id} className="absolute bottom-0 text-4xl sm:text-6xl pointer-events-none animate-[floatUp_4s_ease-out_forwards]" style={{ left: `${f.x}%` }}>{EMOJI[f.kind]}</span>)}
      {live && !phone && <div className="absolute top-4 right-4 flex gap-3 text-lg bg-black/50 rounded-full px-4 py-1" data-testid="premiere-counts">{Object.entries(s.counts || {}).map(([k, v]) => <span key={k}>{EMOJI[k]} {v}</span>)}</div>}
      {phone && live && (
        <div className="absolute bottom-6 inset-x-0 flex justify-center gap-3" data-testid="premiere-reactions">
          {Object.entries(EMOJI).map(([k, e]) => <button key={k} onClick={() => react(k)} className="w-14 h-14 rounded-full bg-white/15 text-3xl active:scale-90 transition-transform" data-testid={`premiere-react-${k}`}>{e}</button>)}
        </div>
      )}
      {!armed && <button onClick={() => setArmed(true)} className="absolute inset-0 z-20 bg-black/80 flex items-center justify-center font-serif text-3xl" data-testid="premiere-arm">Tap once to get the screen ready (turns on sound)</button>}
      <style>{"@keyframes floatUp{0%{transform:translateY(0);opacity:1}100%{transform:translateY(-90vh);opacity:0}}"}</style>
    </div>
  );
}
